"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const TableSortLabel_1 = tslib_1.__importDefault(require("@mui/material/TableSortLabel"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 *
 * @category component
 */
const TextHeaderCell = ({ text, textTypographyProps, tooltip, sort, columnId, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps },
        react_1.default.createElement(Tooltip_1.default, { ...tooltip }, !sort ? (react_1.default.createElement(Typography_1.default, { variant: "inherit", ...textTypographyProps }, text)) : (react_1.default.createElement(TableSortLabel_1.default, { active: sort?.isSorted, direction: sort?.direction, onClick: () => sort.onSortByChangeFn(columnId) },
            react_1.default.createElement(Typography_1.default, { variant: "inherit", ...textTypographyProps }, text))))));
};
exports.default = TextHeaderCell;
